import styled from "styled-components";
import { Button, Box, Constants } from "@nubeteck/components";

const { maxDevice } = Constants;

export const MobileMenuContainerStyled = styled(Box)`
  display: none;
  position: fixed;
  transition: all ease 0.7s;
  top: 0;
  right: 0;
  left: 0;
  height: 100vh;
  z-index: 20;
  padding: 20px 0px;
  background-color: ${({ theme }) => theme.colors.colorAccent};

  @media ${maxDevice.laptop} {
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transform: translateX(400px);
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    overflow: auto;

    &.is-visible {
      visibility: visible;
      opacity: 1;
      pointer-events: all;
      transform: translateX(0px);
    }
  }

  @media (max-width: 1280px) {
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transform: translateX(400px);
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    overflow: auto;

    &.is-visible {
      visibility: visible;
      opacity: 1;
      pointer-events: all;
      transform: translateX(0px);
    }
  }
`;

export const MobileMenuStyled = styled.ul`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 0;
  font-size: 20px;
  padding: 0;
  width: 105%;

  li {
    list-style-type: none;
    min-width: 100%;
    text-align: center;

    a {
      color: white;
      padding: 13px 40px;
      gap: 12px;
      width: 100%;
      display: flex;
      text-align: start;
      justify-content: flex-start;
      text-decoration: none;
      &.is-active {
        background-color: ${({ theme }) => theme.colors.primary500};
      }
    }
  }
`;

export const MenuButton = styled(Button)`
  &:hover {
    background: transparent !important;
    color: #fff !important;
  }
  width: 100%;
`;

export const MobileUserSectionStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  text-align: start;
  width: 100%;
  gap: 12px;
  padding-bottom: 50px;

  button {
    color: white;
    font-size: 20px;
    height: 35px;
    padding-left: 40px;
    span {
      height: 100%;
    }
  }

  /* Estilos para los contenedores de LanguageSwitcher y roles */
  > div {
    width: 100%;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    padding-bottom: 8px;
    margin-bottom: 8px;
    
    &:last-of-type {
      border-bottom: none;
      margin-bottom: 0;
    }
  }
`;
export const UserNameStyled = styled.span`
  color: white;
  font-size: 22px;
  font-weight: bolder;
  margin: 20px 0 10px 0;
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  right: 7px;
`;
export const BottomShapeStyled = styled(Box)`
  position: absolute;
  bottom: 60px;
  right: 0px;
`;
export const TopShapeStyled = styled(Box)`
  position: absolute;
  top: 0px;
  left: 0px;
`;

export const MenuButtonStyled = styled(Button)`
  color: white;
  padding: 8px;
  margin-bottom: 10px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  min-width: 40px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 30;
  position: relative;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.5);
  }
  
  &:active {
    background: rgba(255, 255, 255, 0.3);
  }
`;

export const LanguageSwitcherContainer = styled.div`
  .language-switcher {
    .lang-toggle {
      background: rgba(255, 255, 255, 0.2);
      border: 1px solid rgba(255, 255, 255, 0.3);
      color: white;
      font-size: 14px;
      padding: 8px 16px;
      border-radius: 20px;
      
      &:hover {
        background: rgba(255, 255, 255, 0.3);
      }
    }
    
    .lang-menu {
      background: white;
      border: 1px solid #e5e7eb;
      border-radius: 10px;
      box-shadow: 0 8px 20px rgba(16,24,40,0.12);
      padding: 8px;
      top: 50px;
      right: 0;
      
      .lang-pill {
        color: #111827;
        background: #fff;
        border: 1px solid #d0d5dd;
        
        &:hover {
          background: #f3f4f6;
        }
        
        &.active {
          background: var(--color-primary, #006aea);
          color: #fff;
          border-color: transparent;
        }
      }
    }
  }
`;

export const RoleSelectorStyled = styled.div`
  color: white;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
`;
